import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import CrisisSection from '../components/CrisisSection';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import Team from '../components/Team';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen text-neutral-900">
      <Navbar />
      <main>
        <Hero />
        <CrisisSection />
        <HowItWorks />
        <Pricing />
        <Team />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
